<script setup lang="ts">
import { useAssignmentsList } from '../model/assignments/assignments-list.hook'
import TableAssignmentTemplates from './assignments/list/TableAssignmentTemplates.vue'
import ModalCreateAssignmentTemplate from './assignments/list/ModalCreateAssignmentTemplate.vue'
import ModalDeleteAssignmentTemplate from './assignments/list/ModalDeleteAssignmentTemplate.vue'
import ModalDuplicateAssignmentTemplate from './assignments/list/ModalDuplicateAssignmentTemplate.vue'

defineOptions({
  name: 'AssignmentsListPage',
})

const {
  refCanView,
} = useAssignmentsList()
</script>

<template>
  <TableAssignmentTemplates v-if="refCanView" />
  <!-- `view-assignment-templates` is enforced server-side (contract §2); this only spares an
       admin who lands here by URL a wall of 403 toasts. -->
  <div
    v-else
    class="assignments-index__denied"
  >
    You do not have access to assignment templates.
  </div>
  <ModalCreateAssignmentTemplate />
  <ModalDeleteAssignmentTemplate />
  <ModalDuplicateAssignmentTemplate />
</template>

<style scoped lang="scss" src="./AssignmentsListPage.scss" />
